import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import {
    IconEclipse,
    IconEnergy,
    IconTemparature
} from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { getKpiStatusColor } from './conditionStatus';
import { driveAnomalyTabs, } from '../../constants';
import SingleLeftPanelItem from '../../../../../PowertrainTools/GatewayManagement/LeftNavLayout/SingleLeftPanelItem';
import { RETRAINING_STATUS } from '../MotorAnomalyDetection/constants';

const DriveAnomalyNavPanel = ({ activeDriveAnomalyTab, setActiveDriveAnomalyTab, energyAnomalyKPI, coolingAnomalyKPI }) => {
    const isCoolingRetraining = coolingAnomalyKPI?.retrainingDetails?.retrainingStatus === RETRAINING_STATUS.TRAINING;
    const coolingStatusColor = isCoolingRetraining ? colors.transparent : getKpiStatusColor(coolingAnomalyKPI);
    const energyStatusColor = getKpiStatusColor(energyAnomalyKPI);

    return (
        <div className='drive-anomaly-left-panel'>
            <SingleLeftPanelItem
                item={{
                    icon: IconTemparature,
                    label: translate('ABB.Powertrain.Frontend.coolingAnomalyDetection'),
                    symbol: <IconEclipse color={coolingStatusColor} isdef={false} />
                }}
                isActive={activeDriveAnomalyTab === driveAnomalyTabs.COOLING}
                onClick={() => setActiveDriveAnomalyTab(driveAnomalyTabs.COOLING)}
            />
            <SingleLeftPanelItem
                item={{
                    icon: IconEnergy,
                    label: translate('ABB.Powertrain.Frontend.energyAnomalyDetection'),
                    symbol: <IconEclipse color={energyStatusColor} isdef={false} />
                }}
                isActive={activeDriveAnomalyTab === driveAnomalyTabs.ENERGY}
                onClick={() => setActiveDriveAnomalyTab(driveAnomalyTabs.ENERGY)}
            />
        </div>
    );
};

DriveAnomalyNavPanel.propTypes = {
    activeDriveAnomalyTab: PropTypes.string.isRequired,
    setActiveDriveAnomalyTab: PropTypes.func.isRequired,
    energyAnomalyKPI: PropTypes.object,
    coolingAnomalyKPI: PropTypes.object
};

export default memo(DriveAnomalyNavPanel);
